// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sa-security-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 20px;
}

.sa-policy-card {
    background: var(--sa-card);
    border-radius: 14px;
    padding: 24px;
    border-left: 4px solid var(--sa-dim);
    transition: all 0.2s;
}

.sa-policy-card:hover {
    border-left-color: var(--sa-accent);
    background: var(--sa-card-hover);
}

.sa-toggle {
    width: 44px;
    height: 22px;
    background: var(--sa-bg);
    border-radius: 11px;
    padding: 3px;
    cursor: pointer;
    position: relative;
    transition: background 0.2s;
}

.sa-toggle.on {
    background: var(--sa-green);
}

.sa-toggle-knob {
    width: 16px;
    height: 16px;
    background: #fff;
    border-radius: 50%;
    transition: transform 0.2s;
}

.sa-toggle.on .sa-toggle-knob {
    transform: translateX(22px);
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/SuperAdmin/SASecurity.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;AACb;;AAEA;IACI,0BAA0B;IAC1B,mBAAmB;IACnB,aAAa;IACb,oCAAoC;IACpC,oBAAoB;AACxB;;AAEA;IACI,mCAAmC;IACnC,gCAAgC;AACpC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,wBAAwB;IACxB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;AAC/B","sourcesContent":[".sa-security-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 20px;\n}\n\n.sa-policy-card {\n    background: var(--sa-card);\n    border-radius: 14px;\n    padding: 24px;\n    border-left: 4px solid var(--sa-dim);\n    transition: all 0.2s;\n}\n\n.sa-policy-card:hover {\n    border-left-color: var(--sa-accent);\n    background: var(--sa-card-hover);\n}\n\n.sa-toggle {\n    width: 44px;\n    height: 22px;\n    background: var(--sa-bg);\n    border-radius: 11px;\n    padding: 3px;\n    cursor: pointer;\n    position: relative;\n    transition: background 0.2s;\n}\n\n.sa-toggle.on {\n    background: var(--sa-green);\n}\n\n.sa-toggle-knob {\n    width: 16px;\n    height: 16px;\n    background: #fff;\n    border-radius: 50%;\n    transition: transform 0.2s;\n}\n\n.sa-toggle.on .sa-toggle-knob {\n    transform: translateX(22px);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
